import metaConfig from "@/config/metaConfig";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const MetaTagsUpdater = () => {
  const location = useLocation();

  const metaTags = metaConfig[location.pathname as keyof typeof metaConfig] || {
    title: "Maharashtra Revenue Department",
    description: "Welcome to Maharashtra Revenue Department",
    keywords: "default, Maharashtra Revenue Department",
    lang: "en",
  };

  return (
    <Helmet>
      <title>{metaTags.title}</title>
      <meta name="description" content={metaTags.description} />
      <meta name="keywords" content={metaTags.keywords} />
    </Helmet>
  );
};

export default MetaTagsUpdater;
